// extracted by mini-css-extract-plugin
export default {"container":"About_container__r8jmh","content":"About_content__o9SNx"};